<template>
  <v-layout
    wrap
    ma-0
    pa-0
    class="justify-center align-center"
  >
    <v-flex
      xs12
      :class="wrapperSpacingClasses"
    >
      <creative
        :template="template"
        :passed-extracted-creative-details="extractedCreativeDetails"
        @on-image-load-started="onImageLoadStarted"
        @on-image-load-finished="onImageLoadFinished"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import {
  VLayout,
  VFlex
} from 'vuetify/lib';
import { mapGetters } from 'vuex';
import Creative from '../../imageCreatives/components/Creative.vue';
export default {
  data(){
    return{
    }
  },
  props: {
    template: {
      type: Object,
      default: null
    },
    extractedCreativeDetails: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'objective', 'offerDetail']),
    wrapperSpacingClasses(){
      let customSpacing = this.$vuetify.breakpoint.smAndDown ? 'px-0 py-0' : 'px-5 py-3';
      return  `ma-0 ${customSpacing}`
    }
  },
  methods: {
    onImageLoadStarted(){
      this.$emit('on-image-load-started');
    },
    onImageLoadFinished(index){
      this.$emit('on-image-load-finished', index)
    }
  },
  components: {
    VLayout,
    VFlex,
    Creative
  }
};
</script>